/**
 * Processes a string containing the csv data and return an array of objects
 * representing the same data
 *
 * @param data String the input data
 * @param numerics Array an array of string column names to parse as floating point numbers
 * @returns Array array of objects
 */
export default function csv(data, numerics) {
  const rows = data
    .split('\n')
    .filter(r => r.length > 0)
    .map(r => r.split(','));

  const headers = rows.shift();

  return rows.map((r) => {
    const obj = {};

    headers.forEach((h, i) => {
      if (numerics.indexOf(h) >= 0) {
        obj[h] = parseFloat(r[i]);
      } else {
        obj[h] = r[i];
      }
    });

    return obj;
  });
}
